import { useState } from 'react';
import styled from 'styled-components';
import { saveAs } from 'file-saver';
import { downloadMedia } from './actions';
import {Loader} from "../../../../../../../../App/AppComponents/Loader"
import { Col } from '../../../../../../../gui/layout/Col';

const StyledUploadedItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  height: fit-content;
  padding: 1.1rem;
  background: #f5f5f5;
  border-radius: 5px;
  
  

  .flex-col {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .flex-row {
    display: flex;
    flex-direction: row;
  }

  img {
    width: 50px;
    height: 50px;
    border-radius: 5px;
  }

  svg {
    /* &:first-of-type {
      margin-right: 1rem;
      margin-left: 3rem;

    } */
  }

  span {
    display: block;
    color: #333333;
    width: fit-content;
    font-size: 1.3rem;

    &.item-name{
      text-overflow: ellipsis;
      white-space: nowrap;
      width: 200px;
      overflow:hidden;
    }

    &.item-date {
      color: #858585;
      margin-right: auto;
    }

    &.item-size {
      color: #858585;
      margin-left: 2rem;
    }
  }
`;

const formatDate = (inputDate) => {
  let date = new Date(inputDate);
  return (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getDate().toString().padStart(2, '0') + '/' + date.getFullYear();
};

const formatSize = (numBytes) => {
  if (numBytes < 1000) {
    return '1kb';
  } else if (numBytes < 1000000) {
    return Math.floor(numBytes / 100) / 10 + 'kb';
  } else {
    return Math.floor(numBytes / 100000) / 10 + 'mb';
  }
};

export const UploadedItem = ({ image, data, fullScreen = true, fromToken=null }) => {
  const [downloading, setDownloading] = useState(false);

  const typeOfUpload = (type) => {
    if (type === 'docx') {
      return (
        <svg width="38" height="50" viewBox="0 0 38 50" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M36.9422 50C37.5195 49.9394 38.0033 49.4194 38 48.8638V14.6842C38 14.2408 37.819 14.0125 37.5548 13.7077L23.3971 0.372943C23.1122 0.103843 22.8537 0.0019886 22.488 0H1.18739C0.565724 0 0 0.541375 0 1.13624V48.8626C0 49.4574 0.565745 49.9988 1.18739 49.9988H36.8121H36.9422L36.9422 50ZM33.918 13.4768H23.713V3.85319L33.918 13.4768Z" fill="#25AED0" />
          <path
            d="M5.384 43.82C5.384 45.728 6.488 47.12 8.204 47.12C9.104 47.12 9.872 46.664 10.328 45.86V47H11.456V38.384H10.244V41.732C9.8 40.952 9.056 40.52 8.204 40.52C6.488 40.52 5.384 41.888 5.384 43.82ZM6.644 43.82C6.644 42.38 7.388 41.588 8.444 41.588C9.452 41.588 10.244 42.368 10.244 43.796C10.244 45.2 9.476 46.04 8.444 46.04C7.388 46.04 6.644 45.236 6.644 43.82ZM15.8048 47.12C17.6048 47.12 18.9248 45.704 18.9248 43.82C18.9248 41.936 17.6048 40.52 15.8048 40.52C14.0048 40.52 12.6848 41.936 12.6848 43.82C12.6848 45.704 14.0048 47.12 15.8048 47.12ZM15.8048 46.052C14.7608 46.052 13.9448 45.212 13.9448 43.82C13.9448 42.428 14.7608 41.6 15.8048 41.6C16.8488 41.6 17.6768 42.428 17.6768 43.82C17.6768 45.212 16.8488 46.052 15.8048 46.052ZM22.6683 47.132C24.2643 47.132 25.3923 46.1 25.6083 44.42H24.3483C24.2043 45.452 23.5803 46.052 22.6803 46.052C21.6363 46.052 20.9523 45.176 20.9523 43.82C20.9523 42.476 21.6363 41.588 22.6803 41.588C23.5683 41.588 24.2043 42.2 24.3363 43.22H25.6083C25.3803 41.564 24.2403 40.52 22.6683 40.52C20.9523 40.52 19.7043 41.9 19.7043 43.82C19.7043 45.764 20.9283 47.132 22.6683 47.132ZM27.2188 47L28.8988 44.468L30.6028 47H31.9948L29.7628 43.784L31.8508 40.64H30.5428L28.9708 43.04L27.3988 40.64H25.9948L28.1068 43.748L25.8508 47H27.2188Z"
            fill="white"
          />
        </svg>
      );
    }
  };

  const onDownloadClick = async () => {
    setDownloading(true);
    try {
      let fileData = await downloadMedia(data._id, fromToken);
      saveAs(fileData, data.fileName);
    } catch (err) {
      console.log(err);
      alert('failed to download media');
    }
    setDownloading(false);
  };

  return (
    <StyledUploadedItem>
      <img src={image} alt="" />
      <Col margin="auto 2rem">
        <span className='item-name'>{data.fileName}</span>
        <div className="flex-row">
          <span className="item-date">{formatDate(data.uploadedAt)}</span>
          <span className="item-size">&nbsp;{formatSize(data.fileSize)}</span>
        </div>
      </Col>
      <div className="icon-buttons">
        {fullScreen && (
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0.713162 0.000142717C0.319492 0.000700904 0 0.320262 0 0.714051C0 0.749077 0.002511 0.783405 0.00753331 0.817872L0.00697529 0.814104V6.43384V6.44389C0.00697529 6.83839 0.327 7.1578 0.720673 7.1578C1.11434 7.1578 1.43437 6.83837 1.43437 6.44389V6.43328V6.43384V2.44597L5.92677 6.93969C6.05609 7.06905 6.23424 7.14846 6.43108 7.14846C6.82546 7.14846 7.14478 6.82834 7.14478 6.43455C7.14478 6.23695 7.06484 6.05888 6.93538 5.92938L2.44298 1.43566H6.43039H6.44043C6.83482 1.43566 7.15413 1.11554 7.15413 0.72175C7.15413 0.327965 6.8348 0.00784213 6.44043 0.00784213H6.42983H0.806745C0.778565 0.00351631 0.745504 0.0010042 0.71244 0.0010042L0.713162 0.000142717ZM19.2663 0.000700904C19.2388 0.00125909 19.2126 0.00377095 19.1869 0.00753883L19.1907 0.00698064H13.569H13.559C13.1646 0.00698064 12.8453 0.326403 12.8453 0.720889C12.8453 1.11539 13.1646 1.4348 13.559 1.4348H13.5696H17.5563L13.0639 5.92852C12.9346 6.05788 12.8545 6.23608 12.8545 6.43369C12.8545 6.82819 13.1745 7.1476 13.5689 7.1476C13.7657 7.1476 13.9445 7.06763 14.0739 6.93883L18.5663 2.44511V6.43298V6.44303C18.5663 6.83753 18.8857 7.15694 19.28 7.15694C19.6744 7.15694 19.9937 6.83751 19.9937 6.44303V6.43242V6.43298V0.808241C19.9975 0.780052 20 0.746981 20 0.713908C20 0.319408 19.6807 0 19.2863 0C19.2795 0 19.2719 0 19.2651 0.000558187L19.2663 0.000700904ZM0.709948 12.8506C0.319885 12.8569 0.00628539 13.1738 0.00628539 13.5645V13.5751V13.5746V19.2868V19.2886V19.2905C0.00628539 19.3111 0.00754091 19.3318 0.00935451 19.3517L0.00879649 19.3486C0.00935451 19.3542 0.00935451 19.3574 0.00935451 19.3605V19.358C0.0111681 19.3792 0.0143766 19.3974 0.0174458 19.4155L0.0168878 19.4112C0.0187014 19.4225 0.0199568 19.4293 0.0212122 19.4356L0.0206542 19.4313C0.035721 19.5006 0.0587392 19.5626 0.0887314 19.6188L0.0869178 19.615C0.0912423 19.6244 0.0944513 19.6294 0.0975205 19.6344L0.0957069 19.6307C0.10631 19.6494 0.115098 19.6644 0.125143 19.6794L0.123329 19.6769C0.127654 19.6844 0.130862 19.6887 0.133931 19.6931L0.132118 19.6905C0.172156 19.7475 0.217773 19.7969 0.269672 19.8387L0.270927 19.84C0.272741 19.8413 0.274694 19.8438 0.277205 19.8456L0.277763 19.8461C0.393971 19.9381 0.541568 19.9949 0.702146 19.9987H0.702704C0.706471 19.9992 0.712051 19.9992 0.718329 19.9992H6.42998H6.44003C6.83441 19.9992 7.15373 19.6798 7.15373 19.2853C7.15373 18.8908 6.8344 18.5714 6.44003 18.5714H6.42943H2.44345L6.93513 14.0777C7.06822 13.9476 7.1508 13.7669 7.1508 13.5663C7.1508 13.1718 6.83148 12.8523 6.43711 12.8523C6.43027 12.8523 6.42274 12.8523 6.4159 12.8529H6.41716C6.22464 12.8585 6.05152 12.9398 5.92653 13.0679L1.43413 17.5617V13.5731V13.5637C1.43413 13.1692 1.1141 12.8498 0.720432 12.8498H0.709132H0.70969L0.709948 12.8506ZM19.2702 12.8506C18.8802 12.8569 18.5666 13.1738 18.5666 13.5645V13.5751V13.5746V17.5632L14.0742 13.0694C13.9442 12.9356 13.7629 12.8531 13.5623 12.8531H13.5618C13.1681 12.8537 12.8486 13.1733 12.8486 13.567C12.8486 13.7677 12.9318 13.949 13.0648 14.0785L17.5565 18.5722H13.5698H13.5598C13.1654 18.5722 12.8461 18.8916 12.8461 19.2861C12.8461 19.6806 13.1654 20 13.5598 20H13.5704H19.2803C19.3553 20 19.4284 19.9881 19.4965 19.9662L19.4915 19.9675C19.4958 19.9657 19.4965 19.965 19.4971 19.965L19.4933 19.9668C19.5202 19.9587 19.542 19.9506 19.5639 19.9411L19.5596 19.9429C19.5651 19.9404 19.5664 19.9399 19.5676 19.9392L19.5639 19.941C19.5883 19.9304 19.6082 19.9203 19.6276 19.9097L19.6239 19.9115C19.6269 19.9097 19.6276 19.9085 19.6282 19.9085L19.6264 19.9097C19.6632 19.8891 19.6945 19.8684 19.7239 19.8454L19.7226 19.8466C19.7332 19.8385 19.7413 19.8316 19.7501 19.8242L19.7489 19.8247C19.765 19.8109 19.7796 19.7972 19.7932 19.7829C19.7938 19.7823 19.7945 19.7816 19.795 19.781C19.8263 19.7485 19.855 19.713 19.8794 19.6742L19.8813 19.6711C19.8794 19.6749 19.88 19.6742 19.88 19.6742L19.8818 19.6704C19.8924 19.6542 19.9043 19.6341 19.9149 19.6135L19.9167 19.6097C19.9149 19.6135 19.9154 19.6128 19.9154 19.6128L19.9172 19.609C19.9366 19.5714 19.9541 19.5278 19.9666 19.4821L19.9679 19.4771C19.9673 19.4809 19.9673 19.4802 19.9673 19.4789L19.9686 19.4739C19.983 19.4227 19.9917 19.3645 19.993 19.3038V19.3032C19.9936 19.2995 19.9936 19.2939 19.9936 19.2876V13.5743V13.5649C19.9936 13.1704 19.6742 12.851 19.2799 12.851H19.2686H19.2691L19.2702 12.8506Z"
              fill="#1F1F1F"
            />
          </svg>
        )}

        {downloading && <Loader size='18px' />}
        {!downloading && (
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onDownloadClick} style={{ cursor: 'pointer' }}>
            <path d="M12.5573 8.1106L8.99986 11.6681L5.44238 8.1106" stroke="#1F1F1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.00021 0.996643V11.6681" stroke="#1F1F1F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M17.7537 13.4457C17.7537 13.0315 17.4179 12.6957 17.0037 12.6957C16.5895 12.6957 16.2537 13.0315 16.2537 13.4457H17.7537ZM1.74707 13.4457C1.74707 13.0315 1.41128 12.6957 0.99707 12.6957C0.582857 12.6957 0.24707 13.0315 0.24707 13.4457H1.74707ZM16.2537 13.4457C16.2537 14.9963 14.9968 16.2532 13.4463 16.2532V17.7532C15.8252 17.7532 17.7537 15.8247 17.7537 13.4457H16.2537ZM13.4463 16.2532H4.55455V17.7532H13.4463V16.2532ZM4.55455 16.2532C3.00402 16.2532 1.74707 14.9963 1.74707 13.4457H0.24707C0.24707 15.8247 2.1756 17.7532 4.55455 17.7532V16.2532Z"
              fill="#1F1F1F"
            />
          </svg>
        )}
      </div>
    </StyledUploadedItem>
  );
};
